/**
 * Channel selector keys used by the campaign-message Preview tab.
 *
 * Distinct from `channelTypes` in `enum/Labels.js`, which maps frontend names
 * to the numeric `message_type` API discriminator (ios_push, android_push,
 * web_push, sms, …). This enum is the dashboard's internal channel-selector
 * vocabulary — it collapses ios_push + android_push into a single `push` tab
 * because the preview surface treats them as one channel.
 *
 * Used as:
 *  - the `activeName` / `activeChannel` value in PreviewContent / StepPreview,
 *  - the `channel` payload field on the `showSendPreview` EventBus event,
 *  - the keys of the `previewComponents` map in PreviewContent.vue.
 */
const PreviewChannelEnum = Object.freeze({
  PUSH: 'push',
  EMAIL: 'email',
  INAPP: 'inapp',
  INBOX: 'inbox'
})

export { PreviewChannelEnum }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/PreviewChannelEnum.js